import React from "react";
import { Table, Tag, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import WidgetWrapper from "../../components/WidgetWrapper";
import { useLoadList } from "../../../../hooks";
import { flightOperationFlightService } from "../../../../api/enhancedApi";

dayjs.extend(utc);

const ActiveFlightsWidget = () => {
    const navigate = useNavigate();

    const { data, isLoading, refetch } = useLoadList("active_flights_widget", flightOperationFlightService.getFlightOperations, {
        page: 1,
        page_size: 10,
        status: "DEPARTED,DELAYED,DIVERTED,SCHEDULED",
        sort_by: "std",
        sort_order: "asc",
        start_date: dayjs().format("YYYY-MM-DD"), // Show from today
    });

    const columns = [
        {
            title: "航班号",
            dataIndex: "flight_number",
            key: "flight_number",
            render: (text) => <a onClick={() => navigate(`/flight-operations/monitor`)}>{text}</a>,
            width: 80,
        },
        {
            title: "航线",
            key: "route",
            render: (_, record) => (
                <span>
                    {record.departure_airport} - {record.arrival_airport}
                </span>
            ),
            width: 100,
        },
        {
            title: "状态",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                let color = "default";
                if (status === "DEPARTED") color = "processing"; // Blue
                if (status === "DELAYED") color = "error"; // Red
                if (status === "DIVERTED") color = "warning"; // Gold
                if (status === "COMPLETED") color = "success"; // Green
                if (status === "SCHEDULED") color = "blue";
                return (
                    <Tag color={color} style={{ border: "none" }}>
                        {status}
                    </Tag>
                );
            },
            width: 90,
        },
        {
            title: "时间 (UTC)",
            key: "time",
            render: (_, record) => {
                const time = record.etd || record.std;
                return <Tooltip title={`STD: ${dayjs.utc(record.std).format("HH:mm")}`}>{dayjs.utc(time).format("HH:mm")}</Tooltip>;
            },
        },
    ];

    return (
        <WidgetWrapper title="今日动态航班" loading={isLoading} onRefresh={refetch} extra={<a onClick={() => navigate("/flight-operations/monitor")}>更多</a>}>
            <Table columns={columns} dataSource={data?.items || []} rowKey="id" pagination={false} size="small" scroll={{ y: 200 }} />
        </WidgetWrapper>
    );
};

export default ActiveFlightsWidget;
